import { ObservableProperty } from "./helpers/observableProperty.js";
const PreviewAspectRatioKey = "PreviewAspectRatio";
const PreviewSizeModeKey = "PreviewSizeMode";
const PreviewFixedWidthKey = "PreviewFixedWidth";
const PreviewFixedHeightKey = "PreviewFixedHeight";
const OldPreviewFillContainerKey = "PreviewFillContainer";
const DefaultPreviewAspectRatio = "1.33333";
const DefaultPreviewFixedWidth = "400";
const DefaultPreviewFixedHeight = "300";
export const FixedMode = "fixed";
export const FillMode = "fill";
const AspectRatioMode = "aspectRatio";
/**
 * Manages the size mode of the preview window, including loading and saving settings to local storage.
 */
export class PreviewSizeManager {
    /**
     * The currently selected mode (e.g. aspectRatio, fixed, fill)
     */
    get mode() {
        return this._mode;
    }
    /**
     * The option selected in the UI, which could be a specific aspect ratio or one of the modes (fill, fixed)
     */
    get selectedModeOption() {
        return this._selectedModeOption;
    }
    /**
     * The options selected in the UI, which could be a specific aspect ratio or one of the modes (fill, fixed)
     */
    set selectedModeOption(value) {
        this._selectedModeOption = value;
        // Interpret mode
        if (value === FillMode) {
            this._mode.value = FillMode;
        }
        else if (value === FixedMode) {
            this._mode.value = FixedMode;
        }
        else if (!isNaN(Number(value))) {
            this._mode.value = AspectRatioMode;
            this.aspectRatio.value = value;
        }
    }
    /**
     * Creates a new PreviewSizeManager instance.
     */
    constructor() {
        // Read current storage keys
        this.aspectRatio = new ObservableProperty(localStorage.getItem(PreviewAspectRatioKey) ?? DefaultPreviewAspectRatio);
        this.fixedWidth = new ObservableProperty(Number.parseInt(localStorage.getItem(PreviewFixedWidthKey) || DefaultPreviewFixedWidth));
        this.fixedHeight = new ObservableProperty(Number.parseInt(localStorage.getItem(PreviewFixedHeightKey) || DefaultPreviewFixedHeight));
        let modeFromStorage = localStorage.getItem(PreviewSizeModeKey);
        // Upgrade from old storage keys
        const oldFillContainer = localStorage.getItem(OldPreviewFillContainerKey);
        if (oldFillContainer !== null) {
            localStorage.removeItem(OldPreviewFillContainerKey);
            if (oldFillContainer) {
                modeFromStorage = FillMode;
            }
        }
        // Convert to a type union with a default
        if (modeFromStorage === null || (modeFromStorage !== AspectRatioMode && modeFromStorage !== FillMode && modeFromStorage !== FixedMode)) {
            modeFromStorage = AspectRatioMode;
        }
        const initialMode = modeFromStorage;
        // Set remaining properties
        this._mode = new ObservableProperty(initialMode);
        this._selectedModeOption = initialMode === AspectRatioMode ? this.aspectRatio.value : initialMode;
        // Set up observers to update local storage and dependent properties
        this._mode.onChangedObservable.add((newMode) => {
            localStorage.setItem(PreviewSizeModeKey, newMode);
        });
        this.aspectRatio.onChangedObservable.add((newAspectRatio) => {
            localStorage.setItem(PreviewAspectRatioKey, newAspectRatio);
        });
        this.fixedWidth.onChangedObservable.add((newFixedWidth) => {
            localStorage.setItem(PreviewFixedWidthKey, newFixedWidth.toString());
        });
        this.fixedHeight.onChangedObservable.add((newFixedHeight) => {
            localStorage.setItem(PreviewFixedHeightKey, newFixedHeight.toString());
        });
    }
}
//# sourceMappingURL=previewSizeManager.js.map